import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Avatar,
  Button,
  Box,
  Chip,
  Grid,
} from "@mui/material";
import moment from "moment";
import { connect } from "react-redux";
import { getEmployeesByGroup } from "../../../store/voting/actions";
import { useEffect, useState } from "react";
import TableSkeleton from "../../common/components/TableSkeleton";

const EmployeesByGroupDialog = ({
  open,
  onClose,
  group,
  getEmployeesByGroup,
}) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  useEffect(() => {
    if (!!group?.id) {
      getEmployeesByGroup(group.id, group.typeId, (status, data) => {
        setLoadingData(status);
        setEmployeeData(data);
      });
    } else setLoadingData(false);

    return () => {
      setLoadingData(true);
    };
  }, []);

  if (!group) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: "20px",
        },
      }}
    >
      <DialogTitle textAlign="center">
        <Avatar
          sx={{
            bgcolor: "#1976d2",
            width: 70,
            height: 70,
            margin: "0 auto",
            fontSize: "2rem",
          }}
        >
          {group.name.charAt(0)}
        </Avatar>
        <Typography variant="h5" mt={2}>
          {group.name}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          <strong>Fiscal Year:</strong>
          {group.fiscalYear}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          <strong>Voting Participation:</strong>
          {group.votedEmployees}/{group.totalEmployees}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box mt={3}>
          <table className="table table-striped table-hover table-sm  fixTableHead mt-0">
            <thead>
              <tr style={{ backgroundColor: "#f0f2f5" }}>
                <th scope="col">Employee Name</th>
                <th scope="col">Position Name </th>
                <th scope="col">Unit Name </th>
                <th scope="col">Has Voted </th>
                {group.typeId === 2 && <th scope="col">Votes </th>}
              </tr>
            </thead>
            {!!loadingData ? (
              <TableSkeleton cols={group.typeId === 2?5:4} rows={14} />
            ) : (
              <>
                <tbody>
                  {employeeData.map((employee, index) => (
                    <tr key={index}>
                      <td>{employee.employeeName}</td>
                      <td>{employee.positionName}</td>
                      <td>{employee.unitName}</td>
                      <td>
                        {employee.hasVoted ? (
                          <span className="text-success"> YES </span>
                        ) : (
                          <span className="text-secondary"> NO </span>
                        )}
                      </td>
                      {group.typeId === 2 && (
                        <th scope="col"> {employee.votes} </th>
                      )}
                    </tr>
                  ))}
                </tbody>
              </>
            )}
          </table>
        </Box>
      </DialogContent>

      <DialogActions sx={{ flexDirection: "column", gap: 1 }}>
        <Button onClick={onClose} variant="contained" fullWidth>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = ({ env, loading }) => {
  return { env, loading };
};

export default connect(mapStateToProps, {
  getEmployeesByGroup,
})(EmployeesByGroupDialog);
